import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import MyImageComponent from '../MyImageComponent';
import logo from '../../assets/webp/logo.webp';
import jobImg from '../../assets/webp/contact.webp';


const CreateJob = () => {
  const [formData, setFormData] = useState({
    title: '',
    experience: '',
    location: '',
    type: 'Full Time',
    shortDescription: '',
    description: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('http://localhost:5000/api/jobs', {
        ...formData,
        status: 'open',
        publishDate: new Date(),
        modifiedDate: new Date()
      });

      if (response.status === 201) {
        setFormSubmitted(true);
        console.log('Job created successfully:', response.data);
      }
    } catch (error) {
      setError('Error creating job');
      console.error('Error creating job:', error);
    }
  };

  const handleGoBack = () => {
    navigate('/admindash');
  };

  return (
    <div className="create-job-section">
      <Container className="courses-section my-5">
        <Row className="justify-content-md-center">
          <Col md={6} className="mb-4">
            <Card className={`contact-us-card ${formSubmitted ? 'flipped' : ''}`}>
              <MyImageComponent src={logo} alt="ISIR.AI Logo" width="60" height="40" className="d-inline-block align-top" loading="eager" />
              {formSubmitted ? (
                <Card.Body className="thank-you-message">
                  <MyImageComponent src={jobImg} alt="Thank You" className="card-img-top" loading="eager" />
                  <Card.Title>Job Created!</Card.Title>
                  <Card.Text>Your job has been created successfully.</Card.Text>
                  <Button variant="primary" onClick={handleGoBack}>
                    Go Back to Admin Dashboard
                  </Button>
                </Card.Body>
              ) : (
                <>
                  <MyImageComponent src={jobImg} alt="Create Job" className="card-img-top" loading="eager" />
                  <Card.Body className="create-job-content">
                    <Card.Title>Create a Job</Card.Title>
                    <Form onSubmit={handleSubmit}>
                      <Form.Group controlId="formTitle" className="form-row">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formExperience" className="form-row">
                        <Form.Label>Experience</Form.Label>
                        <Form.Control
                          type="text"
                          name="experience"
                          value={formData.experience}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formLocation" className="form-row">
                        <Form.Label>Location</Form.Label>
                        <Form.Control
                          type="text"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formType" className="form-row">
                        <Form.Label>Job Type</Form.Label>
                        <Form.Control
                          as="select"
                          name="type"
                          value={formData.type}
                          onChange={handleChange}
                          required
                        >
                          <option value="Full Time">Full Time</option>
                          <option value="Part Time">Part Time</option>
                          <option value="Contract">Contract</option>
                          <option value="Freelance">Freelance</option>
                        </Form.Control>
                      </Form.Group>

                      <Form.Group controlId="formShortDescription" className="form-row">
                        <Form.Label>Short Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="shortDescription"
                          value={formData.shortDescription}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group controlId="formDescription" className="form-row">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          rows={4}
                          required
                        />
                      </Form.Group>

                      {error && <p className="text-danger">{error}</p>}

                      <Button variant="primary" type="submit">
                        Create Job
                      </Button>
                    </Form>
                  </Card.Body>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CreateJob;
